import { sendReport, extractReportIdFromResponse } from "./sendReport";
import { getReportRole, normalizePlayerName } from "./stageReportSync";

function backendBase() {
  return String(process.env.REACT_APP_BACKEND_URL || "").replace(/\/+$/, "");
}

function isDemoUser(user) {
  return user?.role === "demobypass" || user?.source === "DEMO";
}

function reportUserId(user) {
  return user?.userId || user?.userid || user?.id || "";
}

/** Old save.php: addReport with 0 points when a poster is first uploaded. */
export async function createPosterExternalReport({ storedUser, adminToken, stageId }) {
  if (isDemoUser(storedUser) || !stageId) return null;

  const uid = reportUserId(storedUser);
  const role = getReportRole(storedUser, false);
  const added = await sendReport({
    sessionId: storedUser.sessionId,
    organizationId: storedUser.organizationId,
    role,
    token: storedUser.token || "",
    points: 0,
    time: "NA",
    gameId: storedUser.gameId,
    name: normalizePlayerName(storedUser) || storedUser.name || "",
    userId: uid,
  });

  const reportId = extractReportIdFromResponse(added);
  if (!reportId) return null;

  const base = backendBase();
  if (base && adminToken) {
    await fetch(`${base}/welcomeStageLinkReport`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${adminToken}`,
      },
      body: JSON.stringify({
        userId: uid,
        sessionId: storedUser.sessionId,
        organizationId: storedUser.organizationId,
        stageId,
        reportId,
      }),
    }).catch((err) => console.error("link poster report:", err));
  }

  return reportId;
}

/** Old likes.php: updateReport with the post's new like count as points. */
export async function updatePosterLikeReport({ storedUser, reportId, points }) {
  if (isDemoUser(storedUser) || !reportId) return;
  const uid = reportUserId(storedUser);
  const role = getReportRole(storedUser, false);
  await sendReport({
    sessionId: storedUser.sessionId,
    organizationId: storedUser.organizationId,
    role,
    token: storedUser.token || "",
    points: Number(points) || 0,
    time: "NA",
    reportId: String(reportId),
    gameId: storedUser.gameId,
    name: normalizePlayerName(storedUser) || storedUser.name || "",
    userId: uid,
  });
}
